module.exports = __webpack_public_path__ + "img/nucarf.1002521b.png";